var map = {
	"./GettyImages-1061685670_crop.jpg": 670,
	"./How_your_diet_can_treat_diseases.jpg": 671,
	"./Moringa-collecting---Mike-goldwater-Alamy.jpg": 672,
	"./The_foods_that_could_prevent_climate_disasters.jpg": 673,
	"./Why-we-need-to-expand-our-crop-menu.jpg": 674,
	"./a-staple-food-withstand-disaster.jpg": 675,
	"./ageing-crisis.jpg": 676,
	"./crucial-ingredient.jpg": 677,
	"./follow_the_food_farmers_on_front_line.jpg": 678,
	"./food-chain-thumbnail-article.jpg": 679,
	"./greenRev_desktop.jpg": 680,
	"./greenRev_mobile.png": 681,
	"./greenRev_tablet.png": 682,
	"./growing-new-farmers.jpg": 683,
	"./how-a-transfarmation-can-help-the-climate.jpg": 684,
	"./how-to-cut-your-foods-carbon-footprint.jpg": 685,
	"./how-to-use-food-waste-for-good.jpg": 686,
	"./how-we-might-build-a-food-utopia.jpg": 687,
	"./it-never-rains.jpg": 688,
	"./seeds-of-life.jpg": 689,
	"./the-farms-being-run-from-space.jpg": 690,
	"./the-hidden-hunger-affectiong-billions.jpg": 691,
	"./the-people-building-edible-cities.jpg": 692,
	"./the-promised-land.jpg": 693,
	"./the-race-to-improve-food-security.jpg": 694,
	"./the-robots-putting-food-on-the-table.jpg": 695,
	"./the-search-for-carbon-neutral-protein.jpg": 696,
	"./the-wasteful-fate-of-a-third-of-food.jpg": 697,
	"./urban-farming.jpg": 698,
	"./vertical_farm.jpg": 699,
	"./why-soil-is-dissappearing-from-our-farms.jpg": 700,
	"./you-are-what-your-food-eats.jpg": 701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;